import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { HttpClientModule } from '@angular/common/http';

// Import AuthGuard
import { AuthGuardService } from './service/auth/auth-guard.service';

// Import Containers
import { DefaultLayoutComponent } from './pages/containers';
import { P404Component } from './pages/error/404.component';
import { P500Component } from './pages/error/500.component';
import { UserloginComponent } from './pages/userlogin/userlogin.component';
import { ChildrenComponent } from './pages/children/children.component';
import { UserprofileComponent } from './pages/userprofile/userprofile.component';
import { FaqComponent } from './pages/faq/faq.component';
import { TermandconditionComponent } from './pages/termandcondition/termandcondition.component';
import { PrivacyComponent } from './pages/privacy/privacy.component';
import { MobileModeGuardService } from './service/mobilemodecheck/mobilemode-guard.service';
import { LateModeGuardService } from './service/late/late-guard.service';

export const routes: Routes = [
  {
    path: '',
    redirectTo: 'home',
    pathMatch: 'full'
  },
  {
    path: '404',
    component: P404Component,
    data: {
      title: 'Page 404'
    }
  },
  {
    path: '500',
    component: P500Component,
    data: {
      title: 'Page 500'
    }
  },
  {
    path: 'userlogin',
    component: UserloginComponent,
    data: {
      title: 'Login Page'
    }
  },
  {
    path: 'userprofile',
    component: UserprofileComponent,
    data: {
      title: 'Profile Page'
    }
  },
  {
    path: 'calendarexception',
    canActivate: [AuthGuardService],
    loadChildren: () => import('./pages/calendar-exception/calendar-exception.module').then(m => m.CalendarExceptionModule)
  },
  {
    path: '',
    component: DefaultLayoutComponent,
    data: {
      title: 'Home'
    },
    
    children: [
      {
        path: 'home',
        // canActivate:[LateModeGuardService],
        loadChildren: () => import('./pages/home/home.module').then(m => m.HomeModule)
      },
      {
        path: 'home/:userToken',
        canActivate: [MobileModeGuardService],
        loadChildren: () => import('./pages/home/home.module').then(m => m.HomeModule)
      },
      {
        path: 'FAQ',
        component: FaqComponent,
        data: {
          title: 'terms and conditions'
        }
      },
      {
        path: 'termsandconditions',
        component: TermandconditionComponent,
        data: {
          title: 'terms and conditions'
        }
      },
      {
        path: 'privacy',
        component: PrivacyComponent,
        data: {
          title: 'Privacy Policy'
        }
      },
      {
        path: 'school',
        loadChildren: () => import('./pages/school/school.module').then(m => m.SchoolModule)
      },
      {
        path: 'children',
        canActivate: [AuthGuardService],
        loadChildren: () => import('./pages/children/children.module').then(m => m.ChildrenModule)
      },
      // {
      //   path: 'adhoc-booking',
      //   canActivate: [AuthGuardService],
      //   loadChildren: () => import('./pages/adhoc-booking/adhoc-booking.module').then(m => m.AdhocBookingModule)
      // },
      {
        path: 'searchbus',
        loadChildren: () => import('./pages/searchbus/searchbus.module').then(m => m.SearchbusModule)
      },
      {
        path: 'forgotpassword',
        loadChildren: () => import('./pages/forgotpassword/forgotpassword.module').then(m => m.ForgotpasswordModule)
      },
      {
        path: 'searchbuschildren',
        loadChildren: () => import('./pages/searchbuschildren/searchbuschildren.module').then(m => m.SearchbuschildrenModule)
      },
      {
        path: 'searchbusmap',
        loadChildren: () => import('./pages/searchbusmap/searchbusmap.module').then(m => m.SearchbusmapModule)
      },
      {
        path: 'error',
        loadChildren: () => import('./pages/error/error.module').then(m => m.ErrorRoutingModule)
      },
      {
        path: 'late',
        loadChildren: () => import('./pages/home/home.module').then(m => m.HomeModule),
        data: {
          isShowLateRoute: true
        }
      },
    ],
    runGuardsAndResolvers: 'always'
  },
  { path: '**', component: P404Component }
];

@NgModule({
  imports: [ RouterModule.forRoot(routes, { onSameUrlNavigation: 'reload' }) , HttpClientModule ],
  exports: [ RouterModule ]
})

export class AppRoutingModule {}
